import WebStore from '../views/webStore/WebStore';
import VipPage from '../views/webStore/VipPage';
import { pageType, viewPage } from '@plugins/biPoint/_configSdkstore';

export default [
  {
    path: '/',
    name: '',
    component: WebStore,
    meta: {
      pageName: pageType.homePage
    },
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.homePage);
      next();
    }
  },
  {
    path: '/vip_score',
    name: 'vipScore',
    component: VipPage,
    meta: {
      pageName: pageType.vipPage
    },
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.vipPage);
      next();
    }
  }
];
